import { useMutation } from '@tanstack/react-query'
import { updateWorkShiftCustomField } from 'api/company'
import { useAuthContext } from 'components/auth'
import { MutationOptions } from 'queries/types'
import { useInvalidateWorkShiftCustomFields } from './useWorkShiftCustomFields'

type UpdateWorkShiftCustomFieldVariables = {
  customFieldId: number
  key: string
}

export function useUpdateWorkShiftCustomFieldMutation(
  options: MutationOptions<
    typeof updateWorkShiftCustomField,
    unknown[],
    UpdateWorkShiftCustomFieldVariables
  > = {}
) {
  const { company } = useAuthContext()
  const { invalidate } = useInvalidateWorkShiftCustomFields()

  return useMutation({
    ...options,
    mutationFn: async ({
      customFieldId,
      key,
    }: UpdateWorkShiftCustomFieldVariables) => {
      if (!company?.id) {
        throw new Error('Company id not found')
      }
      return updateWorkShiftCustomField(company.id, customFieldId, { key })
    },
    onSuccess: async (...args) => {
      await invalidate()
      await options.onSuccess?.(...args)
    },
  })
}
